import { mapState, mapActions } from 'vuex';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import VueRadioGroup from '@ui-common/vue-radio-group';
const forint = new Intl.NumberFormat('hu-HU', { maximumFractionDigits: 0, minimumFractionDigits: 0 }).format;
const szazalek = new Intl.NumberFormat('hu-HU', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format;
const deviza = new Intl.NumberFormat('hu-HU', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format;
const pdfApiUrlBase = '/apps/mifid/api/calculator/treasury/pdf?';

export default {
	components: {
		VueSelect,
		VueSelectOption,
		VueRadioGroup
	},
	computed: {
		...mapState('mifidTreasury', [
			'defaultUgyfelTipus',
			'ugyfelTipusok',
			'szolgaltatasok',
			'otpUgyfelTipusok',
			'piac',
			'calculated',
			'loading',
			'result',
			'masterDataLoaded'
		]),
		readyToCalculation() {
			return this.otpUgyfelTipusok.length
				? !!this.selectedValues.otpUgyfelTipus && !!this.selectedValues.piac && !!this.selectedValues.szolgaltatas && !!this.selectedValues.ugyfelTipus
				: !!this.selectedValues.piac && !!this.selectedValues.szolgaltatas && !!this.selectedValues.ugyfelTipus;
		},
		ugyfelTipusokOptions() {
			return this.ugyfelTipusok.map((ugyfelTipus) => {
				return {
					key: ugyfelTipus.id,
					value: ugyfelTipus.name
				};
			});
		}
	},
	created() {
		this.getMasterData({
			ugyfelTipus: this.defaultUgyfelTipus,
			szolgaltatas: ''
		});
	},
	data() {
		return {
			selectedValues: {
				ugyfelTipus: 'TKU',
				piac: null,
				szolgaltatas: null,
				otpUgyfelTipus: null
			},
			osszeg: '',
			devizanem: '',
			gaCategory: 'MIFID Global Markets kalkulátor',
			gaCategoryEdu: 'MIFID Global Markets kalkulátor - EDU'
		};
	},
	filters: {
		osszegFormat(value, devizanem) {
			return devizanem == 'Ft' ? forint(value) : deviza(value);
		},
		szazalek
	},
	methods: {
		calculation() {
			let params = {
				ugyfelTipus: this.selectedValues.ugyfelTipus,
				szolgaltatas: this.selectedValues.szolgaltatas,
				piac: this.selectedValues.piac
			};
			if (this.selectedValues.otpUgyfelTipus) {
				params.otpUgyfelTipus = this.selectedValues.otpUgyfelTipus;
			}
			this.calculate(params);
		},
		downloadPDF() {
			let params = {
				ugyfelTipus: this.selectedValues.ugyfelTipus,
				szolgaltatas: this.selectedValues.szolgaltatas,
				piac: this.selectedValues.piac
			};
			if (this.selectedValues.otpUgyfelTipus) {
				params.otpUgyfelTipus = this.selectedValues.otpUgyfelTipus;
			}
			let url = pdfApiUrlBase;
			Object.keys(params).forEach((key) => {
				url += key + '=' + encodeURIComponent(params[key]) + '&';
			});
			window.open(url, 'calculatorPDF');
		},
		devizaNeve(devizaParam, rag) {
			let retValue = '';
			switch (('' + devizaParam).toLowerCase()) {
				case 'ft':
					retValue = 'magyar forint' + (rag ? 'ban' : '');
					break;
				case 'eur':
					retValue = 'euró' + (rag ? 'ban' : '');
					break;
				case 'usd':
					retValue = 'amerikai dollár' + (rag ? 'ban' : '');
					break;
				case 'gbp':
					retValue = 'angol font' + (rag ? 'ban' : '');
					break;
				case 'jpy':
					retValue = 'japán jen' + (rag ? 'ben' : '');
					break;
				default:
					retValue = devizaParam + (rag ? 'ben' : '');
			}
			return retValue;
		},
		...mapActions('mifidTreasury', ['getMasterData', 'calculate', 'clearCalculated'])
	},
	watch: {
		defaultUgyfelTipus(val) {
			this.selectedValues.ugyfelTipus = val;
		},
		selectedValues: {
			handler() {
				this.clearCalculated();
			},
			deep: true
		},
		result: {
			handler() {
				setTimeout(() => {
					this.$scrollTo(this.$refs.topOfResult, { duration: 500 });
				});
			},
			deep: true
		},
		['selectedValues.ugyfelTipus'](val) {
			this.selectedValues.szolgaltatas = null;
			this.selectedValues.piac = null;
			this.selectedValues.otpUgyfelTipus = null;
			this.getMasterData({
				ugyfelTipus: val,
				szolgaltatas: ''
			});
		},
		['selectedValues.szolgaltatas'](val) {
			this.selectedValues.otpUgyfelTipus = null;
			this.getMasterData({
				ugyfelTipus: this.selectedValues.ugyfelTipus,
				szolgaltatas: val
			});
		},
		piac(val) {
			this.selectedValues.piac = val;
		}
	}
};
